import {
  put, select, takeLatest, takeEvery,
} from 'redux-saga/effects';
import { change, untouch } from 'redux-form';
import * as Actions from '../actions/studentActions';

export function* getFormInfo() {
  const { form } = yield select((state) => state);
  const formName = Object.keys(form)[0];
  const { student_id } = form[`${formName}`].values;
  const name = Object.keys(form[`${formName}`].values).some((x) => x === 'parent_status') ? 'parent_status[student_statuses_attributes][0][student_attributes]' : 'student';
  return {
    formName,
    name,
    student_id,
  };
}

export function* setCurrentStudent() {
  const { formName, name, student_id } = yield getFormInfo();
  let values = {
    first_name: undefined,
    last_name: undefined,
    first_name_kana: undefined,
    last_name_kana: undefined,
    gendar: undefined,
    birthday: undefined,
    phone: undefined,
    other_health: undefined,
  };
  if (student_id !== 'new') {
    const { students } = yield select((state) => state.student);
    values = students.find((x) => x.id === Number.parseInt(student_id, 10));
  }
  yield put(Actions.setCurrentStudent(values));
  if (name === 'parent_status[student_statuses_attributes][0][student_attributes]') {
    yield put(change(formName, `${name}[id]`, values.id));
    yield put(change(formName, 'parent_status[student_statuses_attributes][0][student_id]', values.id));
  }
  yield put(change(formName, `${name}[first_name]`, values.first_name));
  yield put(change(formName, `${name}[last_name]`, values.last_name));
  yield put(change(formName, `${name}[first_name_kana]`, values.first_name_kana));
  yield put(change(formName, `${name}[last_name_kana]`, values.last_name_kana));
  yield put(change(formName, `${name}[gender]`, values.gender));
  yield put(change(formName, `${name}[birthday]`, values.birthday));
  yield put(change(formName, `${name}[phone]`, values.phone));
  yield put(change(formName, `${name}[email]`, values.email));
  yield put(change(formName, `${name}[other_health]`, values.other_health));
}

export function* onChangeFormInput(action) {
  const { field } = action.meta;
  if (field !== 'student_id') {
    return;
  }
  const { formName, name } = yield getFormInfo();
  yield put(untouch(formName, `${name}[first_name]`));
  yield put(untouch(formName, `${name}[last_name]`));
  yield put(untouch(formName, `${name}[first_name_kana]`));
  yield put(untouch(formName, `${name}[last_name_kana]`));
  yield put(untouch(formName, `${name}[gender]`));
  yield put(untouch(formName, `${name}[grade]`));
  yield put(untouch(formName, `${name}[birthday]`));
  yield put(untouch(formName, `${name}[phone]`));
  yield put(untouch(formName, `${name}[other_health]`));
  yield put(untouch(formName, `${name}[birthday_year]`));
  yield put(untouch(formName, `${name}[birthday_month]`));
  yield put(untouch(formName, `${name}[birthday_day]`));
  yield put({ type: Actions.SAGA_SET_CURRENT_STUDENT });
}

export default function* saga() {
  yield takeLatest(Actions.SAGA_SET_CURRENT_STUDENT, setCurrentStudent);
  yield takeEvery('@@redux-form/CHANGE', onChangeFormInput);
}
